import {Box, Typography} from '@mui/material';
import {number} from 'prop-types';

import {FONT_FAMILIES} from '../../../../const';
import ExportProgressBar from '../ExportProgressBar/ExportProgressBar';

const ProgressBarSection = ({numberOfPagesExported = 0, totalNumberOfPages = 0, numberOfVisualsExported = 0, totalNumberOfVisualsInPage = 0}) => (
  <>
    <Box mt={4}>
      <Typography fontFamily={FONT_FAMILIES.BODY} fontWeight="bold" fontSize={13} textTransform="uppercase" color="text.secondary">
        Pages du rapport exportées
      </Typography>
      <ExportProgressBar value={numberOfPagesExported} maxValue={totalNumberOfPages} />
    </Box>

    <Box mt={2}>
      <Typography fontFamily={FONT_FAMILIES.BODY} fontWeight="bold" fontSize={13} textTransform="uppercase" color="text.secondary">
        Visuels exportés sur la page
      </Typography>
      <ExportProgressBar value={numberOfVisualsExported} maxValue={totalNumberOfVisualsInPage} />
    </Box>
  </>
);

ProgressBarSection.propTypes = {
  numberOfPagesExported: number,
  totalNumberOfPages: number,
  numberOfVisualsExported: number,
  totalNumberOfVisualsInPage: number
};

export default ProgressBarSection;
